<template>
  <b-container>
        <location
            v-if="editLocation"
            v-model="editLocation" 
            :wantEdit="true"
            confirmTitle="Save"
            :isBusy="isBusy"
            @onSubmitLocation="onSubmitLocation"   />
  </b-container>
</template>

<script>
import Swal from 'sweetalert2'
import { mapState } from 'vuex'
import Location from '@/components/portal/Location'

export default {
    name : 'Setting',
    components:{ Location },
    props : [],
    data() { 
        return { 
            isBusy : false,
            editLocation : null, }
    },
    computed : {
        ...mapState({
            store: 'store',
            userInfo: 'userInfo'
        }),
    },
    watch : {            
        userInfo : {
            deep : true,
            immediate : true,
            handler(newValue) {
				this.editLocation = this.$deepCopy(newValue.location);
            }
        }
    },
    created() { 
		this.editLocation = this.$deepCopy(this.userInfo.location);
    },
    destroyed() { },
    methods: {		
        onSubmitLocation(_location) {
            this.isBusy = true;
            this.$store.dispatch('apiEditLocation', _location)
                    .then(({status, error}) => {
                        this.isBusy = false;
                        if(status) {                       
                            this.userInfo["location"] = _location;
                            this.$store.commit('updateUserInfo', this.userInfo)
                            Swal.fire('Updated', 'Successfully Updated', 'success')
                        } else {
                            console.error("error",error)
                            Swal.fire('Error',error.msg,'error')
                        }
                    })
                    .catch(({error, msgError})=>{
                        this.isBusy = false;
                        console.error("apiEditLocation-E", error)  
                        Swal.fire('Error',msgError,'error')   
                    })            
        }
    },
}
</script>

<style>

</style>